import axios from 'axios';
import { PhotoDocumentActionTypes } from '.';

const endpoint = `${process.env.REACT_APP_EYS_API_HOST}/photodocument`;

export function findPhotoDocuments(type, yourId) {
  const request = axios.get(`${endpoint}?page=1&perPage=1000000&type=${type}&yourId=${yourId}`);
  return {
    type: PhotoDocumentActionTypes.FIND,
    payload: request
  };
}

export function addPhotoDocument(photoDocument, callback, errorCallback) {

  const request = axios.post(`${endpoint}`, photoDocument);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: PhotoDocumentActionTypes.CREATE,
    payload: request
  }
}

export function deletePhotoDocument(id, callback, errorCallback) {

  const request = axios.delete(`${endpoint}/${id}`);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: PhotoDocumentActionTypes.DELETE,
    payload: request
  }
}


// WEBPACK FOOTER //
// ./src/actions/photodocument.action.js